import { VendorResponseTypes } from './searchPackage';
import * as moment from 'moment';
export class HardDeclineReason
{
    id: number;
    displayMessage: string;
    searchType: VendorResponseTypes;
    userId: number;
    declineNote : string;
    dateSet : moment.Moment;
    userName : string;
    screeningId : number;
    isCrimGridHardDecline : boolean;
    overrideCalcs : boolean;
    overrideNote : string
    declineReasonId : number;
    
    public get noteToShow() : string {
        return this.overrideCalcs ? this.overrideNote : this.declineNote;
    }
    
}

export interface ReviewRequiredReason {
    id: number;
    //ScreeningId: number;
    //ReportNumber: number;
    reasonText: number;

}